import * as Yup from 'yup';

export default function CompOffRequestSchema() {
  return Yup.object({
    workDate: Yup.date().nullable().required('Work date is required'),
    hoursWorked: Yup.number()
      .typeError('Hours worked must be a number')
      .min(4, 'Hours worked must be at least 4 hours to be eligible for comp-off')
      .max(24, 'Hours worked cannot exceed 24')
      .required('Hours worked is required'),
    tasksCompleted: Yup.string()
      .max(1000, 'Tasks completed must be less than 1000 characters')
      .required('Tasks completed is required'),
    description: Yup.string()
      .max(1000, 'Description must be less than 1000 characters')
      .required('Description is required'),
    reviewers: Yup.array()
      .of(Yup.number().integer().positive())
      .min(1, 'At least one reviewer must be selected')
      .required('At least one reviewer is required'),
  });
}
